import type { DosageSuffixPhraseKind } from '@/utils/dosageLimit/getPadItemDosageSuffix';
import type { PriceTier } from './MedicationPadItemEditor.types';

export const MEDICATION_SELECTOR_LABEL = 'Medication selector';
export const SHOW_MORE_PRODUCTS_BUTTON_LABEL = 'Show more products';
export const MAX_DAILY_DOSE_CHIP_TOOLTIP =
  "This can't be edited or removed. Updates automatically when the maximum daily dose is changed.";
/** Read before the chips' labels and tooltips, as the dosage textarea's description */
export const DOSAGE_SUFFIX_CHIPS_DESCRIPTION = 'Added to the end of the dosage instructions:';
export const DOSAGE_CHIP_LAYER_TEST_ID = 'dosage-chip-layer';
export const DOSAGE_SUFFIX_CHIP_TEST_ID = 'dosage-suffix-chip';
export const CALCULATED_DISPENSE_AMOUNT_TEST_ID = 'calculated-dispense-amount';
export const FORMULATION_DISPENSE_TOTAL_LABEL = 'Total for all';
export const FORMULATION_DISPENSE_TOTAL_TEST_ID = 'formulation-dispense-total';
export const MONTHLY_DISPENSE_LIMIT_CHIP_TOOLTIP =
  "This can't be edited or removed. Updates automatically when the dispense limit is changed.";
/** Tooltip of the chip for each dosage suffix phrase; the phrases' order comes from `getPadItemDosageSuffixPhrases` */
export const DOSAGE_SUFFIX_CHIP_TOOLTIP: Record<DosageSuffixPhraseKind, string> = {
  maxDailyDose: MAX_DAILY_DOSE_CHIP_TOOLTIP,
  monthlyDispenseLimit: MONTHLY_DISPENSE_LIMIT_CHIP_TOOLTIP,
};

export const PRICE_TIER_ORDER: PriceTier[] = ['Budget', 'Standard', 'Premium'];
export const PRICE_TIER_RANGES: Record<PriceTier, { min: number; max: number }> = {
  Budget: { min: 0, max: 100 },
  Standard: { min: 100, max: 130 },
  Premium: { min: 130, max: Infinity },
};
